(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aevumo-product-detail"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.aevumo-pdp').forEach((root)=>{const figures=[...root.querySelectorAll('.aevumo-pdp__media figure')];root.querySelectorAll('.aevumo-pdp__thumbs a').forEach((thumb)=>thumb.addEventListener('click',(event)=>{event.preventDefault();const target=root.querySelector(thumb.getAttribute('href'));if(!target)return;figures.forEach((figure)=>figure.style.display='none');target.style.display='block';root.querySelectorAll('.aevumo-pdp__thumbs a').forEach((item)=>item.removeAttribute('aria-current'));thumb.setAttribute('aria-current','true')}));const quantity=root.querySelector('input[name="quantity"]');const buttons=root.querySelectorAll('.aevumo-pdp__quantity button');buttons[0]?.addEventListener('click',()=>quantity.value=Math.max(1,Number(quantity.value||1)-1));buttons[1]?.addEventListener('click',()=>quantity.value=Number(quantity.value||1)+1);const feed=root.querySelector('[data-product-feed]');if(feed){const observer=new IntersectionObserver((entries)=>{if(!entries[0].isIntersecting)return;observer.disconnect();fetch(feed.dataset.url).then((response)=>response.text()).then((text)=>{const page=new DOMParser().parseFromString(text,'text/html');const incoming=page.querySelector('[data-product-feed]');if(incoming&&incoming.innerHTML.trim())feed.innerHTML=incoming.innerHTML})},{rootMargin:'0px 0px 300px 0px'});observer.observe(feed)}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
